import * as S from './styles'

interface SmallLoadingProps {
  className?: string
}

const SmallLoading = ({ className }: SmallLoadingProps) => {
  return (
    <S.SmallLoadingWrapper className={className}>
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </S.SmallLoadingWrapper>
  )
}

export default SmallLoading
